export enum DraftReplies {
	NONE = "NONE",
	ONE = "ONE",
	THREE = "THREE",
}
